import { render, staticRenderFns } from "./PlaceEditTool.vue?vue&type=template&id=35dcd666&scoped=true"
import script from "./PlaceEditTool.vue?vue&type=script&lang=js"
export * from "./PlaceEditTool.vue?vue&type=script&lang=js"
import style0 from "./PlaceEditTool.vue?vue&type=style&index=0&id=35dcd666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcd666",
  null
  
)

export default component.exports